var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBinaryCode2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.94,
    y1: 65.58,
    x2: 52.94,
    y2: 88.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 79.82,
    y1: 103.33,
    x2: 79.82,
    y2: 126.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.94,
    y1: 138.8,
    x2: 52.94,
    y2: 161.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.4,65.58v23.2m-42-23.2v23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.89,103.33v23.2m-42-23.2v23.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.4,138.8V162m-42-23.19V162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.17,88.19h-.52a7.51,7.51,0,0,1-7.6-7.37V73.54a7.51,7.51,0,0,1,7.6-7.37h.52a7.52,7.52,0,0,1,7.6,7.37v7.28A7.52,7.52,0,0,1,160.17,88.19Zm-42.5,0h-.51a7.52,7.52,0,0,1-7.61-7.37V73.54a7.52,7.52,0,0,1,7.61-7.37h.51a7.51,7.51,0,0,1,7.6,7.37v7.28A7.51,7.51,0,0,1,117.67,88.19Zm-42.5,0h-.51a7.51,7.51,0,0,1-7.6-7.37V73.54a7.51,7.51,0,0,1,7.6-7.37h.51a7.51,7.51,0,0,1,7.6,7.37v7.28A7.51,7.51,0,0,1,75.17,88.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.09,125.94h-.51a7.52,7.52,0,0,1-7.61-7.37v-7.28a7.52,7.52,0,0,1,7.61-7.37h.51a7.51,7.51,0,0,1,7.6,7.37v7.28A7.51,7.51,0,0,1,144.09,125.94Zm-42.5,0h-.51a7.52,7.52,0,0,1-7.61-7.37v-7.28a7.52,7.52,0,0,1,7.61-7.37h.51a7.51,7.51,0,0,1,7.6,7.37v7.28A7.51,7.51,0,0,1,101.59,125.94Zm-42.5,0h-.51a7.51,7.51,0,0,1-7.6-7.37v-7.28a7.51,7.51,0,0,1,7.6-7.37h.51a7.51,7.51,0,0,1,7.6,7.37v7.28A7.51,7.51,0,0,1,59.09,125.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.17,161.41h-.52a7.51,7.51,0,0,1-7.6-7.38v-7.28a7.51,7.51,0,0,1,7.6-7.37h.52a7.52,7.52,0,0,1,7.6,7.37V154A7.52,7.52,0,0,1,160.17,161.41Zm-42.5,0h-.51a7.52,7.52,0,0,1-7.61-7.38v-7.28a7.52,7.52,0,0,1,7.61-7.37h.51a7.51,7.51,0,0,1,7.6,7.37V154A7.51,7.51,0,0,1,117.67,161.41Zm-42.5,0h-.51a7.51,7.51,0,0,1-7.6-7.38v-7.28a7.51,7.51,0,0,1,7.6-7.37h.51a7.51,7.51,0,0,1,7.6,7.37V154A7.51,7.51,0,0,1,75.17,161.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaryCode2);
export default __webpack_public_path__ + "static/media/BINARY_CODE_2.e13f501726ba7f35e5d2bdb7d8de6810.svg";
export { ForwardRef as ReactComponent };